import React from 'react';
import { useSelector } from 'react-redux';
import {
    Designation2,
    LineMob,
    Designation3,
    HeaderTextContainer,
    HeaderGridContainer,
    BodyGridContainer,
    Name,
    User1,
    Designation1,
    ValidDate,
    Created,
    Container2,
    UserName,
    Date,
    Line,
    DistrictGrid,
    DistrictGridMob,
    TerritoryGridMob,
    DistrictHeading,
    DistrictName,
    TerritoryGrid,
    TerritoryHeading,
    TerritoryName,
    ValidDateMob,
    CreatedByMob,
    ValidDateHeadingMob,
    BodyTextContainer,
} from './index.styled';
import { useTranslation } from 'react-i18next';
import { sizes } from 'src/styles/Media.styled';
import { AccountListContainer } from '../Tab2/index.styled';
import { getDisplayDateNoTZ } from 'src/utils/dateUtils';

// eslint-disable-next-line no-unused-vars
const ProxiesTabs1 = (props) => {
    const { t } = useTranslation();
    const proxyList = useSelector(
        (state) =>
            state.AdminProxyReducer.proxyList &&
            state.AdminProxyReducer.proxyList.proxyRecordsForUser
    );

    return (
        <>
            <AccountListContainer>
                {proxyList ? (
                    <HeaderGridContainer
                        container
                        justifyContent={'space-between'}
                        direction="row"
                    >
                        <HeaderTextContainer
                            item
                            xs={12}
                            sm={4}
                            md={4}
                            lg={4}
                            xl={4}
                            mobile={12}
                        >
                            {t('proxies.proxyname')}
                        </HeaderTextContainer>

                        <HeaderTextContainer
                            item
                            xs={12}
                            sm={4}
                            md={4}
                            lg={4}
                            xl={4}
                            mobile={12}
                        >
                            {t('proxies.validDates')}
                        </HeaderTextContainer>

                        <HeaderTextContainer
                            item
                            xs={12}
                            sm={4}
                            md={4}
                            lg={4}
                            xl={4}
                            mobile={12}
                        >
                            {t('proxies.created')}
                        </HeaderTextContainer>
                    </HeaderGridContainer>
                ) : (
                    <BodyTextContainer>
                        {t('proxies.noproxyforanyone')}
                    </BodyTextContainer>
                )}

                {proxyList &&
                    proxyList
                        .sort(function (a, b) {
                            return a.user.displayName.split(' ')[1] >
                                b.user.displayName.split(' ')[1]
                                ? 1
                                : b.user.displayName.split(' ')[1] >
                                  a.user.displayName.split(' ')[1]
                                ? -1
                                : 0;
                        })

                        .map((listData, index) => {
                            return (
                                <BodyGridContainer
                                    container
                                    key={index}
                                    // justifyContent={'space-between'}
                                >
                                    <Name
                                        item
                                        xs={12}
                                        sm={4}
                                        md={4}
                                        lg={4}
                                        xl={4}
                                        mobile={12}
                                    >
                                        <User1>
                                            {listData.proxyEmployee.displayName}
                                        </User1>
                                        <Designation1>
                                            {
                                                listData.proxyEmployee
                                                    .employeeRole
                                            }
                                        </Designation1>
                                    </Name>
                                    <Container2>
                                        <ValidDateHeadingMob mobile={12}>
                                            {t('proxies.validDates')}
                                        </ValidDateHeadingMob>
                                        <ValidDateMob>
                                            {' '}
                                            {getDisplayDateNoTZ(
                                                listData.fromDate
                                            )}{' '}
                                            {t('proxies.updateAProxy.to')}{' '}
                                            {listData.toDate
                                                ? getDisplayDateNoTZ(
                                                      listData.toDate
                                                  )
                                                : t('proxies.noEndDate')}{' '}
                                        </ValidDateMob>
                                    </Container2>
                                    <ValidDate
                                        item
                                        xs={12}
                                        sm={4}
                                        md={4}
                                        lg={4}
                                        xl={4}
                                        mobile={12}
                                    >
                                        {getDisplayDateNoTZ(
                                            listData.fromDate
                                        )}{' '}
                                        {t('proxies.updateAProxy.to')}{' '}
                                        {listData.toDate
                                            ? getDisplayDateNoTZ(
                                                  listData.toDate
                                              )
                                            : t('proxies.noEndDate')}{' '}
                                    </ValidDate>

                                    <CreatedByMob>
                                        {t('proxies.createdby')}
                                    </CreatedByMob>
                                    <Created
                                        item
                                        xs={12}
                                        sm={4}
                                        md={4}
                                        lg={4}
                                        xl={4}
                                        mobile={12}
                                    >
                                        <UserName>
                                            {
                                                listData.createdByEmployee
                                                    .displayName
                                            }
                                        </UserName>
                                        <Designation3>
                                            {
                                                listData.createdByEmployee
                                                    .employeeRole
                                            }
                                        </Designation3>
                                        <Designation2>
                                            {
                                                listData.createdByEmployee
                                                    .employeeRole
                                            }
                                        </Designation2>
                                        <LineMob>|</LineMob>
                                        <Date>
                                            {' '}
                                            {getDisplayDateNoTZ(
                                                listData.creationDate
                                            )}
                                        </Date>
                                    </Created>
                                    {/* <Line></Line> */}

                                    {listData.address &&
                                        listData.address.map(
                                            (address, index) => {
                                                return (
                                                    <div
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        key={index}
                                                    >
                                                        <Line></Line>
                                                        <div
                                                            style={{
                                                                display:
                                                                    window.innerWidth >=
                                                                    sizes.mobileDevice
                                                                        ? 'flex'
                                                                        : 'block',
                                                                justifyContent:
                                                                    'space-between',
                                                            }}
                                                        >
                                                            <DistrictGrid
                                                                item
                                                                xs={12}
                                                                sm={5}
                                                                md={5}
                                                                lg={5}
                                                                xl={3}
                                                                mobile={12}
                                                                style={{
                                                                    marginLeft:
                                                                        '4.4%',
                                                                }}
                                                            >
                                                                {listData.address ? (
                                                                    <>
                                                                        <DistrictHeading>
                                                                            {t(
                                                                                'proxies.district'
                                                                            )}
                                                                        </DistrictHeading>
                                                                        <DistrictName>
                                                                            {
                                                                                address.district
                                                                            }
                                                                        </DistrictName>
                                                                    </>
                                                                ) : (
                                                                    ''
                                                                )}
                                                            </DistrictGrid>

                                                            <DistrictGridMob
                                                                item
                                                                xs={12}
                                                                sm={3}
                                                                md={3}
                                                                lg={3}
                                                                xl={3}
                                                                mobile={12}
                                                                style={{
                                                                    textAlign:
                                                                        'left',
                                                                }}
                                                            >
                                                                {listData.address ? (
                                                                    <>
                                                                        <DistrictHeading>
                                                                            {t(
                                                                                'proxies.district'
                                                                            )}
                                                                        </DistrictHeading>
                                                                        <DistrictName>
                                                                            {
                                                                                address.district
                                                                            }
                                                                        </DistrictName>
                                                                    </>
                                                                ) : (
                                                                    ''
                                                                )}
                                                            </DistrictGridMob>
                                                            {address.territory && (
                                                                <>
                                                                    <TerritoryGrid
                                                                        item
                                                                        xs={12}
                                                                        sm={6}
                                                                        md={6}
                                                                        lg={6}
                                                                        xl={4}
                                                                        mobile={
                                                                            12
                                                                        }
                                                                        style={{
                                                                            marginLeft:
                                                                            '34%',
                                                                        }}
                                                                    >
                                                                        {listData.address ? (
                                                                            <>
                                                                                <TerritoryHeading>
                                                                                    {t(
                                                                                        'proxies.territory'
                                                                                    )}
                                                                                </TerritoryHeading>
                                                                                <TerritoryName isMobile={false}>
                                                                                    {
                                                                                        address.territory
                                                                                    }
                                                                                </TerritoryName>
                                                                            </>
                                                                        ) : (
                                                                            ''
                                                                        )}
                                                                    </TerritoryGrid>

                                                                    <TerritoryGridMob
                                                                        item
                                                                        xs={12}
                                                                        sm={4}
                                                                        md={4}
                                                                        lg={4}
                                                                        xl={4}
                                                                        mobile={
                                                                            12
                                                                        }
                                                                        style={{
                                                                            textAlign:
                                                                                'left',
                                                                        }}
                                                                    >
                                                                        {listData.address ? (
                                                                            <>
                                                                                <TerritoryHeading>
                                                                                    {t(
                                                                                        'proxies.territory'
                                                                                    )}
                                                                                </TerritoryHeading>
                                                                                <TerritoryName isMobile={true}>
                                                                                    {
                                                                                        address.territory
                                                                                    }
                                                                                </TerritoryName>
                                                                            </>
                                                                        ) : (
                                                                            ''
                                                                        )}
                                                                    </TerritoryGridMob>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                );
                                            }
                                        )}
                                </BodyGridContainer>
                            );
                        })}
            </AccountListContainer>
        </>
    );
};
export default ProxiesTabs1;
